export function formatDateView(dateString) {
    if (!dateString && dateString !== 0) return "";
    // Backend pode retornar array [ano, mes, dia], string ISO, timestamp ou Date
    if (Array.isArray(dateString)) {
        const [year, month, day] = dateString;
        return `${String(day).padStart(2,'0')}/${String(month).padStart(2,'0')}/${year}`;
    }
    if (dateString instanceof Date) {
        const d = dateString;
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }
    if (typeof dateString === 'number') {
        const d = new Date(dateString);
        if (isNaN(d.getTime())) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }
    const s = String(dateString).trim();
    // Already in dd/mm/yyyy
    const ddmmyyyy = s.match(/^\d{2}\/\d{2}\/\d{4}$/);
    if (ddmmyyyy) return s;
    // Try ISO-like YYYY-MM-DD or full ISO
    const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return `${day}/${month}/${year}`;
    }
    // Fallback: try Date parse
    const parsed = new Date(s);
    if (!isNaN(parsed.getTime())) {
        const day = String(parsed.getDate()).padStart(2, '0');
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const year = parsed.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return '';
}

export function formatYearView(dateString) {
    if (!dateString) return "";
    if (Array.isArray(dateString)) return String(dateString[0]);
    return String(dateString).substring(0, 4);
}

// Converte array [year,month,day] ou string ISO para "YYYY-MM-DD" (formato de input type=date)
export function toIsoDate(val) {
    if (!val) return '';
    if (Array.isArray(val)) {
        const [year, month, day] = val;
        return `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    }
    return String(val).substring(0, 10);
}

export function formatTimeView(timeString) {
    if (!timeString) {
        return "";
    }
    // Garante que a string tem pelo menos 5 caracteres (HH:mm)
    return timeString.substring(0, 5);
}

// Função para calcular dias úteis anteriores
export function calcularDiasUteisAnteriores(data, dias) {
    const newDate = new Date(data);
    let diasRestantes = dias;

    while (diasRestantes > 0) {
        newDate.setDate(newDate.getDate() - 1);

        // Verifica se não é sábado (6) ou domingo (0)
        if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
            diasRestantes--;
        }
    }
}
